import React from 'react';
import c, { browserNotSupportedText } from '../../config/constants';
import h from '../../helpers/common';

const BrowserNotSupported = () => {
    const language = h.getLang();
    return (
        <div className="settings-warning">
            <span className="settings-warning-icon">
                <img src="images/settings-warning_icon.svg" alt="" />
            </span>
            <p className="settings-warning-desc">
                <strong>
                    {language === c.LANG_AR ? browserNotSupportedText.TITLE_AR : browserNotSupportedText.TITLE_EN}
                </strong>{' '}
                <br />
                <span
                    dangerouslySetInnerHTML={{
                        __html:
                            language === c.LANG_AR ? browserNotSupportedText.TEXT_AR : browserNotSupportedText.TEXT_EN,
                    }}
                />
            </p>
        </div>
    );
};

export default BrowserNotSupported;
